// extracted by mini-css-extract-plugin
export default {"mailing":"ProfileMailing_mailing__+zhEH","mailing__primary":"ProfileMailing_mailing__primary__7STFU","mailing__secondary":"ProfileMailing_mailing__secondary__HaToe"};